// extracted by mini-css-extract-plugin
export var dividerLine = "_5f-0";
export var errorBackground = "_5f-1";